module.exports = __webpack_public_path__ + "img/web6.d98dcf54.png";